<template>
    <div class="row">
        <div class="col">
            <form v-on:submit.prevent="submit" method="POST" novalidate>
                <div class="row">
                    <div class="col-12">
                        <div class="form-group">
                            <label for="form-input-password" class="bmd-label-floating">{{ $t('form.password.input.password') }}</label>
                            <input type="password" name="form-input-password" v-model="form.fields.password" class="form-control" id="form-input-password">
                        </div>
                    </div>
                </div>

                <button type="submit" class="btn btn-primary btn-raised">{{ $t('form.password.input.submit') }}</button>
            </form>

            <div class="alert alert-success" role="alert" v-if="form.status=='successs'">
                {{ $t('form.password.submission.successful') }}
            </div>

            <div class="alert alert-danger" role="alert" v-if="form.status=='failed'">
                {{ $t('form.password.submission.failed') }}
            </div>
        </div>

    </div>
</template>

<script>
    import {sha256, sha224} from 'js-sha256';
    import ContactForm from './ContactForm';

    export default {
        name: "PasswordForm",
        components: {ContactForm},
        data: function () {
            return {
                form: {
                    status: null,
                    fields: {
                        password: null
                    }
                }
            }
        },
        methods: {
            submit() {

                // virtual modal for this object
                var vm = this;
                // Send google event when password was entered
                if(vm.$store.state.gdpr.accepted) {
                    vm.$gtag.event('password_entered', { 'event_category': 'engagement', 'event_label': 'Submission of password' })
                }

                // resetting form status
                vm.form.status = null;

                // Hah! :)
                // Did you think you could see the password here? ;-) Nice try!
                if (this.form.fields.password != null && this.form.fields.password.length > 0) {

                    var sha256obj = sha256.create();
                    sha256obj.update(this.form.fields.password);
                    let hash = sha256obj.hex();

                    this.$http.get('/' + hash)
                        .then(function (data) {

                            // Send google event when password was valid
                            if(vm.$store.state.gdpr.accepted) {
                                vm.$gtag.event('password_valid', { 'event_category': 'engagement', 'event_label': 'Valid password submission' })
                            }

                            vm.form.status       = 'success';
                            // You guessed the right passsword, redirecting you
                            window.location.href = '/' + hash;
                        })
                        .catch(function (error) {

                            // Send google event when password was invalid
                            if(vm.$store.state.gdpr.accepted) {
                                vm.$gtag.event('password_invalid', { 'event_category': 'engagement', 'event_label': 'Invalid password submission' })
                            }

                            if (error.response) {
                                vm.form.status = 'failed';
                            }
                        });
                } else {
                    vm.form.status = 'failed';
                }
            }
        }
    }
</script>

<style scoped>

</style>